var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import addCanvasToPdfPage from "../PaperHubClient/NcodedDocGenerator/addCanvasToPdfPage";
import renderBlueprintedPdfPage from "../PaperHubClient/NcodedDocGenerator/convertPdfPageColor";
import { putNcodeOnCanvas } from "../PaperHubClient/NcodedDocGenerator/prepareNcodeSurface";
import upscaleCanvas from "../PaperHubClient/NcodedDocGenerator/upscaleCanvas";
const additionalSteps = 2;
export function generatePodV2_page(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { sobp, pdf, pageIndex, printOption, pg, requestNcodeGzipFunc, access_token, destPdf, } = args;
        // return 값
        const ret = {
            ok: false,
            errorMsg: "",
            blob: undefined,
        };
        const nproj_sobp = sobp;
        // const temp_sobp = { ...sobp, page: sobp.page + pageIndex };
        // const print_sobp = nproj_sobp || temp_sobp;
        const print_sobp = nproj_sobp;
        // const printOption = cloneObj(g_defaultPrintOption);
        const pdfSurface = yield renderBlueprintedPdfPage({ printOption, pdf, pageIndex, dpi: 300 });
        // 원래 캔버스를 600dpi 용으로 바꾸고
        const canvas_600dpi = upscaleCanvas(pdfSurface.canvas, 300, 600);
        // 코드의 이미지 URL을 받고
        // const pg = json.pages[pageIndex];
        const size = {
            unit: "mm",
            name: "A4",
            width: pg.size_pu.width / 72 * 25.4,
            height: pg.size_pu.height / 72 * 25.4,
        };
        const gzRet = yield requestNcodeGzipFunc(print_sobp, size, true);
        if (!gzRet.ok) {
            ret.errorMsg = "서버에서 인쇄용 코드를 다운로드하지 못했습니다. 인증 관련의 문제를 확인하세요.";
            return ret;
        }
        // 코드를 얹자
        yield putNcodeOnCanvas({
            canvas: canvas_600dpi,
            sobp_for_print: print_sobp,
            ncodeUrl: gzRet.url,
            dpi: 600,
            ncodeText: undefined,
            httpOptions: {
                method: 'GET',
                headers: {
                    'Accept-Encoding': 'application/gzip',
                    'Authorization': `bearer ${access_token}`,
                }
            }
        });
        // PDF 페이지를 추가
        yield addCanvasToPdfPage(destPdf, canvas_600dpi, size, false);
        ret.ok = true;
        return ret;
    });
}
export function generatePodV2_async(args) {
    return new Promise((resolve, reject) => {
        generatePodV2_page(args).then(ret => resolve(ret));
    });
}
//# sourceMappingURL=generatePodV2_page.js.map